import React from 'react';

import ABTest from '../../../../abtest/components/abtest';
import { ParentProductDetail } from '../../parent-product-detail';
import { ProductDetail } from './default-product-detail';
//import PDPAlertBanner from '../../pdp-alert-banner';
import { ErrorBoundary } from '../../../../shared/components/error-boundary';
import Breadcrumb from '../../../../shared/components/breadcrumb';
import FreeShippingBanner from '../../../../shared/components/free-shipping-banner';
import FBMessengerBanner from '../../../../shared/components/facebook-messenger-banner';
import PaypalBanner from '../../pdp-paypal-banner';
import PDPValueProp from '../../pdp-value-prop';
import CarePackPromo from '../../carepack-promo';
import PDPImage from '../../pdp-image-container';
import { Helpers } from '../../../../core/src/helpers';

import '../../../css/default-pdp-template.less';

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

class DefaultContentTemplate extends React.PureComponent {

    changeColor = (key, selectedColor) => {
        const { colorGroup, changeColor } = this.props;
        changeColor(selectedColor, colorGroup)
    }

    render() {
        const { getModelId, handleTabChange, modifyProductWithVariant,
            updateSelectedAddOns, selectedColor, product,
            colorGroup, PurchaseButton, enableShippingBanner, showCarepackModule,
            carePacks, isSmb, device, disableAlertBanner, totalPrice, hasBundle, showPaypalBanner } = this.props;
        const isMobileView = device === 'mobile';
        const { pdpConfig = EMPTY_OBJECT, asyncDataLoaded, seo = EMPTY_OBJECT, attributes = EMPTY_OBJECT, eol, bundle } = product;
        const { pdpValueProp = EMPTY_OBJECT } = pdpConfig;
        const { valueProp = EMPTY_OBJECT } = pdpValueProp;
        const { breadcrumbs = EMPTY_ARRAY } = seo;
        const { plcode } = attributes;
        const showHalfValueProp = (showCarepackModule || hasBundle) && !isMobileView;
        const subCat = plcode && Helpers.getMappedSubCat(plcode);
        return (
            <div className={`pdp-top-default ${showCarepackModule || hasBundle ? 'with-bundle' : ''}`}>
                <div className='pdp-breadcrumb-container'>
                    {
                        !product.fromReduxCache &&
                        <Breadcrumb
                            productId={product.prodId !== product.sku ? product.prodId : undefined}
                            templateKey="pdp"
                            product={product}
                            modelId={getModelId()}
                            customBreadcrumbs={breadcrumbs}
                            unlinkTrailing
                            showJsonLd
                        />
                    }
                </div>
                <div className="pdp-content clearfix">
                    <div className="pdp-left">
                        {!isMobileView && <PDPImage
                            sku={product.sku}
                            defaultImages={product.defaultImages}
                            selectedColor={product.selectedColor}
                            images={product.images} />}
                        {showHalfValueProp &&
                            <PDPValueProp
                                configText={valueProp.configText}
                                configLink={valueProp.configLink}
                                customCSS={valueProp.customCSS}
                                customClass={'with-bundle'}
                            />}

                    </div>
                    <div className="pdp-right">
                        <ErrorBoundary>
                            {
                                product.prdClass === "PRT" ?
                                    <ParentProductDetail
                                        product={product}
                                        handleTabChange={handleTabChange}
                                        purchaseButton={PurchaseButton}
                                        modifyProductWithVariant={modifyProductWithVariant}
                                        onAddOnChange={updateSelectedAddOns}
                                        isMobileView={isMobileView}
                                        totalPrice={totalPrice}
                                        showCarepackModule={showCarepackModule}
                                        carePacks={carePacks}
                                    /> :
                                    <ProductDetail
                                        product={product}
                                        handleTabChange={handleTabChange}
                                        colorGroup={colorGroup}
                                        selectedColor={colorGroup.values[selectedColor] || EMPTY_OBJECT}
                                        changeColor={this.changeColor}
                                        purchaseButton={PurchaseButton}
                                        onAddOnChange={updateSelectedAddOns}
                                        isMobileView={isMobileView}
                                        totalPrice={totalPrice}
                                        showCarepackModule={showCarepackModule}
                                        carePacks={carePacks}
                                    />
                            }
                        </ErrorBoundary>
                    </div>
                </div>
                {/* <PDPAlertBanner displayCondition={ disableAlertBanner }>
                <p>For expert advice, price matching, or help with orders, call <a href="tel:+1-866-625-6132">1-866-625-6132</a>.</p>
            </PDPAlertBanner> */}
                { !isMobileView && <CarePackPromo />}
                { enableShippingBanner && <FreeShippingBanner product={product} />}
                <div className={`banner_container ${isMobileView ? "mobile" : 'desktop'}`}>

                    {!showHalfValueProp &&
                        <PDPValueProp
                            configText={valueProp.configText}
                            configLink={valueProp.configLink}
                            customCSS={valueProp.customCSS}
                        />}

                    <ABTest experimentID="18248691377" timeout={0}>
                        {(data) => {
                            const { prefix, omni, base, variation, render } = data;
                            return subCat === 'ink' && data && render && variation &&
                                <FBMessengerBanner
                                    DATA_REF='U2FsdGVkX18v4Il1/rckUlQ6CZhy/4/FTWFtGBZBe+c='
                                    prefix={prefix}
                                    isMobileView={isMobileView}
                                    omni={omni}
                                    base={base}
                                    variation={variation}
                                    imgsrc={!isMobileView && variation && variation === 'var1' ? null : 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/low-ink-large1585101442757431.png'}
                                    header='Need a reminder?'
                                    detail='Be notified on Facebook Messenger the next time your HP inkjet printer runs low on ink.'
                                />
                        }}
                    </ABTest>
                    {
                        showPaypalBanner && <PaypalBanner product={product} className={showHalfValueProp ? 'without-vp' : 'with-vp'} />
                    }
                </div>
            </div>
        )
    }
}


export default DefaultContentTemplate;
